import { useContext, useLayoutEffect, useState } from "react";
import CustomizerContext from "../../../../../../_helper/Customizer";
import {
  Description,
  Status,
  Name,
  Code,
  MaReportClass,
  GeneralLedgerGroup,
} from "../../../../../../Constant";

import { toast } from "react-toastify";
import useAuth from "../../../../../../Hooks/useAuth";
import useAxiosPrivate from "../../../../../../Hooks/useAxiosPrivate";
import { FinanceMaReportClassApi, financesGeneralLedgerGroupApi, HrmGradeGroupApi } from "../../../../../../api";
import { createDropdownField } from "../../../../../../Data/FormField/PublicData";

export default function useFinanceMaReportClassForm() {
  const axiosPrivate = useAxiosPrivate();
  const formTitle = MaReportClass;
  const { userOrganisationId }: any = useAuth();
  const [formFields, setFormFields] = useState<any[]>([
    {
      id: "name",
      name: "name",
      label: Name,
      type: "text",
      value: "",
      required: true,
      colSize: 12,
    },

    {
      id: "description",
      name: "description",
      label: Description,
      type: "textarea",
      value: "",
      required: true,
      colSize: 12,
    },
    {
      id: "is_active",
      name: "is_active",
      label: Status,
      type: "switch",
      value: "1",
      colSize: 12,
    },
  ]);

  const generalLedgerGroupDropDown = createDropdownField(
      axiosPrivate,
      "gl_group_id",
      "gl_group_id",
      GeneralLedgerGroup,
      `${financesGeneralLedgerGroupApi}?with_trashed=${false}&organisation_id=${userOrganisationId}`,
      "",
      12
  );

  // ?? Call on every dependent change
  async function updateFields() {
    const updatedFields = [generalLedgerGroupDropDown, ...formFields];
    await generalLedgerGroupDropDown.fetchOptions();
    setFormFields(updatedFields);
  }

  useLayoutEffect(() => {
    //?? Updates all fields once component is mounted
    updateFields();
  }, []);

  const { layoutURL } = useContext(CustomizerContext);
  const backBtn = `${process.env.PUBLIC_URL}/finance/settings/ma-report-classes/${layoutURL}`;

  const onSubmit = async (data: any) => {
    data.organisation_id = userOrganisationId;
    // console.log(data);
    await axiosPrivate
      .post(FinanceMaReportClassApi, data)
      .then((_res) => {
        toast.success(`${_res.data.name} Created Successfully.`);
      })
      .catch((err) => {
        if (err.response && err.response.status === 422) {
          toast.error("Validation Errors");
        } else if (err.response && err.response.status === 400) {
          toast.error(err.response.data.detail);
        } else {
          toast.error("Whoops! Something went wrong");
        }
        throw err;
        //toast.error(err.response.message || "Whoops! Something went wrong");
      });
  };

  return { formTitle, formFields, backBtn, onSubmit };
}
